import { ActionItem } from '../../libs/gs-component-form';
import { RouterContext } from '../../libs/gs-component-right-rail';
import React, { useContext } from 'react';

import styles from './deleteWebsite.scss';
import { Section } from './Section';
import { TrackingContext } from '../../TrackingContext';

export const DeleteWebsite: React.FC = () => {
  const { push } = useContext(RouterContext);
  const { track } = useContext(TrackingContext);

  const onClick = (): void => {
    track('Wedding Website Deletion Interaction', {
      action: 'delete initiated',
    });

    push('deactivate');
  };

  return (
    <Section className={styles.container}>
      <ActionItem type="remove" onClick={onClick}>
        Deactivate your wedding website
      </ActionItem>
    </Section>
  );
};
